import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Avatar } from "../../../../../../components";
import { envConfig } from "../../../../../../config/env.config";
import { EFileType } from "../../../../../../models/common/models.enum";
import { IAttachmentFile } from "../../../../../../models/Task";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import ImageCustom from "../../../../../../components/ImageCustom";
import { useApi } from "../../../../../../hooks/useApi.hook";
import UploadFileService from "../../../../../../services/api/uploadFile.service";
import { IComment, IDownloadFile } from "../../../../../../models/comment";
import { b64toBlob } from "../../../../../../common/handles/common.handles";
import FileImage from "./FileImage";
import { BorderColorRounded, DownloadRounded } from "@mui/icons-material";
import "react-quill/dist/quill.core.css";
import CommentInput from "./CommentInput";
import CommentService from "../../../../../../services/api/comment.service";
import { toggleMessage } from "../../../../../../components/Toast/Toast";
import { set } from "lodash";
import { t } from "i18next";
import { ITokenPayload } from "@/models/user";
import { jwtDecode } from "jwt-decode";

type Props = {
  id: string;
  name: string;
  time: Date | null;
  content: string;
  avatar: string;
  attachmentFiles?: IAttachmentFile[];
  margin?: string;
  isCreate: boolean;
  refetch?: Function;
};

const CommentBox = (props: Props) => {
  type FileWithMeta = {
    id: string;
    file: File;
  };

  const { id, name, time, content, avatar, attachmentFiles, margin, refetch } =
    props;
  const [files, setfiles] = useState<File[]>([]);
  const [token, setToken] = useState<ITokenPayload>();

  const [existingFiles, setExistingFiles] = useState<FileWithMeta[]>([]);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<any>(null);
  const create = useApi<IComment>({});

  const downloadFile = useApi<IDownloadFile>({});

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "70vw",
    maxHeight: "100vh"
    // bgcolor: "background.paper"
  };

  const styleModalUpdate = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "70vw",
    maxHeight: "100vh",
    backgroundColor: "#ffffff",
    padding: "10px"
    // bgcolor: "background.paper"
  };
  const [isOpenUpdateModel, setIsOpenUpdateModel] = useState(false);
  const handleCloseModelUpdate = () => setIsOpenUpdateModel(false);
  const uploadFileReply = useApi<IAttachmentFile[]>({});

  const updateReply = useApi<IComment>({});

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [comment, setComment] = useState<IComment>();
  const [attachmentFileChange, setAttachmentFileChange] =
    useState<IAttachmentFile[]>();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode<ITokenPayload>(token);

      setToken(decoded);
    }
  }, []);

  function handleDownloadFile(file: IAttachmentFile) {
    downloadFile.request(
      UploadFileService.downloadFile({
        path: file.path,
        fileName: file.fileName
      }).then(response => {
        if (response.success) {
          const blob = b64toBlob(
            response.data.fileContent,
            response.data.fileName
          );
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", response.data.fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode!.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      })
    );
  }

  const handleSubmit = () => {
    const filesData = new FormData();
    filesData.append("FolderName", "Comment_" + token?.connectString);
    files
      .filter(e => e.size > 0)
      .forEach(file => filesData.append("Files", file));

    if (files.length) {
      uploadFileReply.request(
        UploadFileService.uploadFile(filesData).then(response => {
          if (response.success && response.data) {
            updateComment(response.data);
          } else {
            toggleMessage({
              type: "error",
              message: response.message ?? ""
            });
          }
        })
      );
    } else {
      updateComment();
    }
  };

  function updateComment(attachmentFiles?: IAttachmentFile[]) {
    let newFile: IAttachmentFile[] = [];
    if (attachmentFileChange?.length) {
      newFile = [...attachmentFileChange, ...(attachmentFiles ?? [])];
    } else {
      newFile = attachmentFiles ?? [];
    }

    updateReply.request(
      CommentService.update({
        id: id,
        description: inputValue,
        attachmentFiles: newFile
      }).then(res => {
        if (res.success) {
          toggleMessage({
            type: "success",
            message: res.message ?? ""
          });
          setInputValue("");
          setExistingFiles([]);
          setfiles([]);
          setIsOpenUpdateModel(false);
          refetch?.();
        } else {
          if (attachmentFiles) {
            uploadFileReply.request(
              UploadFileService.deleteFiles(attachmentFiles)
            );
          }
        }
      })
    );
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      const list = Array.from(e.target?.files);
      setfiles(files.concat(list));
    }
  };

  const handleDeleteFile = (file: File) => {
    const newFiles = files.filter(f => f !== file);
    setfiles(newFiles);
  };

  const handleExistingFiles = (file: FileWithMeta) => {
    const newFiles = existingFiles.filter(f => f.id !== file.id);
    const newAttachmentFileChange = attachmentFileChange?.filter(
      f => f.id !== file.id
    );
    setAttachmentFileChange(newAttachmentFileChange);
    setExistingFiles(newFiles);
  };

  const handleOpenUpdateComment = async (commentId: string) => {
    const res = await CommentService.getSingle(commentId);

    if (res.success) {
      const files: FileWithMeta[] = res.data.attachmentFiles.map(
        (item: any) => {
          const blob = new Blob([], { type: item.contentType });
          const file = new File([blob], item.fileName, {
            type: item.contentType
          });
          return { id: item.id, file };
        }
      );

      setInputValue(res.data.description);
      setAttachmentFileChange(res.data.attachmentFiles);
      setExistingFiles(files);
      setComment(res.data);
    } else {
      toggleMessage({
        type: "error",
        message: res.message ?? ""
      });
    }

    setIsOpenUpdateModel(true);
  };
  return (
    // <Box margin={margin} display="flex">
    //   <Avatar src={avatar} width="28px" height="28px" />
    //   <Box
    //     marginLeft="12px"
    //     flexGrow={1}
    //     sx={{
    //       backgroundColor: "#F5F7F8",
    //       borderRadius: "8px",
    //       padding: "8px 14px"
    //     }}
    //   >
    //     <Box flexGrow={1} display="flex">
    //       <Typography variant="subtitle2" fontSize="12px">
    //         {name}
    //       </Typography>
    //       <Typography variant="caption" fontSize="10px" marginLeft="8px">
    //         {moment(time).fromNow()}
    //       </Typography>
    //     </Box>
    //     <Box marginTop="4px">
    //       {/* <Typography variant="caption">{content}</Typography> */}
    //       <div
    //         // ref={containerRef}
    //         // style={{
    //         //   maxHeight: isFullDescription
    //         //     ? "none"
    //         //     : `${maxHeight}px`,
    //         //   overflow: "hidden",
    //         //   transition: "max-height 0.3s ease"
    //         // }}
    //         dangerouslySetInnerHTML={{
    //           __html: content ?? ""
    //         }}
    //       />
    //       <Box
    //         marginTop="8px"
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         {attachmentFiles &&
    //           attachmentFiles.map((file, idx) => (
    //             <Button
    //               key={idx}
    //               color="info"
    //               onClick={() => handleDownloadFile(file)}
    //             >
    //               <Box display="flex" alignItems="center" marginBottom="12px">
    //                 <FileImage type={file.extension ?? EFileType.doc} />
    //                 <Typography variant="caption" margin="0 8px">
    //                   {file.fileName}
    //                 </Typography>
    //                 <CloudDownloadOutlinedIcon
    //                   sx={{ fontSize: 16, color: "GrayText" }}
    //                 />
    //               </Box>
    //             </Button>
    //           ))}
    //       </Box>
    //     </Box>
    //   </Box>
    // </Box>
    <Box display="flex" marginBottom="14px">
      <Box>
        <Avatar src={avatar} width="28px" height="28px" />
      </Box>
      <Box marginLeft="10px">
        <Box
          sx={{
            backgroundColor: props.isCreate ? "#73b0ed12" : "#F5F7F8",
            borderRadius: "8px",
            padding: "12px 16px"
            // flexGrow: 1
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              display: "flex",
              color: "#596970",
              fontSize: "12px",
              marginBottom: "8px"
            }}
          >
            {name}
            <span>
              <Typography variant="caption" marginLeft="8px" fontSize="11px">
                {moment(time).fromNow()}
              </Typography>
            </span>
            <Button
              style={{
                marginLeft: "8px"
              }}
              onClick={() => handleOpenUpdateComment(id)}
            >
              <BorderColorRounded color="info" sx={{ fontSize: "12px" }} />
            </Button>

            <Modal open={isOpenUpdateModel} onClose={handleCloseModelUpdate}>
              <Box sx={styleModalUpdate}>
                <Box sx={{ fontWeight: "bold", fontSize: "15px" }}>
                  {t("Comment.EditComment")}
                </Box>
                <CommentInput
                  existingFiles={existingFiles}
                  files={files}
                  isLoading={create.loading}
                  inputRef={inputRef}
                  onSubmit={handleSubmit}
                  onDelete={handleDeleteFile}
                  onDeleteExistingFiles={handleExistingFiles}
                  value={inputValue}
                  onChange={(e: string) => {
                    setInputValue(e);
                  }}
                  handleFileChange={handleFileChange}
                />
              </Box>
            </Modal>
          </Typography>
          <div
            className="view ql-editor"
            dangerouslySetInnerHTML={{
              __html: content ?? ""
            }}
          />
          {attachmentFiles &&
            attachmentFiles.map((file, idx) =>
              file.extension === EFileType.png ||
              file.extension === EFileType.jpeg ||
              file.extension === EFileType.jpg ? (
                <Box marginTop="12px">
                  <ImageCustom
                    src={envConfig.MEDIA_ENDPOINT + file.path}
                    height="100px"
                    width="auto"
                    borderRadius="8px"
                    onClick={() => setOpen(true)}
                  />
                  <Modal open={open} onClose={handleClose}>
                    <Box sx={style}>
                      <Box>
                        <Button
                          endIcon={<DownloadRounded />}
                          sx={{ color: "white", marginBottom: "8px" }}
                        >
                          Tải xuống
                        </Button>
                      </Box>
                      <ImageCustom
                        src={envConfig.MEDIA_ENDPOINT + file.path}
                        height="auto"
                        width="auto"
                      />
                    </Box>
                  </Modal>

                  <Typography variant="caption">{file.fileName}</Typography>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" margin="8px 0">
                  <FileImage type={file.extension ?? EFileType.doc} />
                  <Typography variant="caption" margin="0 8px">
                    {file.fileName}
                  </Typography>
                  <Button
                    key={idx}
                    color="info"
                    onClick={() => handleDownloadFile(file)}
                  >
                    <CloudDownloadOutlinedIcon
                      sx={{ fontSize: 16, color: "GrayText" }}
                    />
                  </Button>
                </Box>
              )
            )}
        </Box>
        {/* <Box display="flex" marginTop="4px" color="#596970">
          <ImageCustom src={IconReply} width="16px" height="16px" />
          <Typography variant="caption" marginLeft="8px">
            Trả lời (2)
          </Typography>
        </Box> */}
      </Box>
    </Box>
  );
};

export default CommentBox;
